import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ILeadershipPosition } from 'src/app/shared/models/leadership-position.model';
import { IOffer } from "src/app/shared/models/offer.model";
import { PopupHttpErrors } from "../decorators/http-error/popup-http-errors.decorator";
import { OfferRepository } from "../repositories/offer.repository";

@Injectable({
    providedIn: 'root'
})
export class OfferService {

    constructor(private offerRepo: OfferRepository) { }

    @PopupHttpErrors()
    public getPendingOffersByApplication(applicationId: number): Observable<Array<IOffer>> {
        return this.offerRepo.getPendingOffersByApplication(applicationId);
    }

    @PopupHttpErrors()
    public getPendingOffersByStudent(pidm: number): Observable<Array<IOffer>> {
        return this.offerRepo.getPendingOffersByStudent(pidm);
    }

    @PopupHttpErrors()
    public getAllActiveOffersCount(): Observable<number> {
        return this.offerRepo.getAllActiveOffersCount();
    }

    @PopupHttpErrors()
    public acceptOffer(offerId: number) : Observable<ILeadershipPosition> {
        return this.offerRepo.acceptOffer(offerId);
    }

}